/**
 * Created with IntelliJ IDEA.
 * User: danielg
 * Date: 1/12/14
 * Time: 5:51 PM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {

    window.lpTag = window.lpTag || {};
    window.lpTag.WebAgent = window.lpTag.WebAgent || {};

    var lpUtils = require('utils/lpUtils');
    var webAgentStatics = require('web-agent-assets-js/lpWebAgentStatics');
    var agentLEManager = require('web-agent-utils/agentLEManager');

    function EngagementNotificationManager(modelController) {
        var App = window.App || {};

        var waitingLinesMap = {};
        var currentFocusedVisitorId = "";
        var agentTabVisible;
        var newAcceptedChats = [];
        var trackedChats = [];

        var chatState = {
            ENDED: 'ended',
            TRANSFERRED: 'transferred',
            CHATTING: 'chatting'
        };

        function getDefaultFocusStateID() {
            var constLE = agentLEManager.getLEConst();
            return (constLE && constLE.FOCUS_STATUS && constLE.FOCUS_STATUS.VISIBLE_FOCUSED) || 2;
        }

        var focusLevel = getDefaultFocusStateID();

        var resumedVisitors = [];
        var isResumed = false;
        modelController.bindModelParam('participants.myEngagements', onNewParticipant);
        modelController.bindModelParam('agent.chatsResumedCount', bindEventsAfterLogin, this);

        function bindEventsAfterLogin() {
            isResumed = true;
            modelController.unbindModelParam('agent.chatsResumedCount', bindEventsAfterLogin, this);
            agentLEManager.onLEEvent("focusStatus:change", changeExternalFocus, this);
            modelController.bindModelParam('chats', onChatAdded, this);
            var channel = webAgentStatics.COMMUNICATION_CHANNELS.QUEUE_ORB;
            lpTag.WebAgent.channel.bind(channel.name, channel.events.acceptSuccess, chatAccepted.bind(this));
        }

        function onNewParticipant(data) {
            if (data && data.newValue) {
                for (var visitorId in data.newValue) {
                    if (!isResumed) {
                        resumedVisitors.push(visitorId + '');
                    }
                    unbindFromUIEvents(visitorId);
                    bindToUIEvents(visitorId);
                }
            }
        }

        function onChatAdded(data) {
            if (data && data.newValue) {
                for (var chatId in data.newValue) {
                    startMonitorChat(chatId);
                }
            }
        }


        function startMonitorChat(chatId) {
            if (trackedChats.indexOf(chatId) === -1) {
                modelController.bindModelParam('chats.' + chatId, onSingleChatModelChange);
                _bindToChatEvents(chatId);
                trackedChats.push(chatId);
            }
        }

        function stopMonitorChat(chatId) {
            // Theoretically, there can be several chatIds per visitorId.
            // However, the orbs (and focus/blur events) are based on visitorIds.
            // So even though we track unread lines based on visitorId - the visitor could still be active
            // after the chat is ended (because there's another chat still active, or there will be a split session)
            _unbindFromChatEvents(chatId);
            var visitorId = modelController.getModelParam('chats.' + chatId + '.visitorInfo.visitorId');
            if (visitorId) {
                clearChatLinesForVisitor(visitorId, true);
            }

            // removing the chat from the tracked list.
            var chatIndex = trackedChats.indexOf(chatId);
            if (chatIndex !== -1) {
                trackedChats.splice(chatIndex, 1);
            }
        }

        function onSingleChatModelChange(data) {
            if (data && data.removedValue) {
                var sKey = data.key.split('.');
                if (sKey.length >= 1) {
                    var chatId = sKey[1];
                    modelController.unbindModelParam('chats.' + chatId, onSingleChatModelChange);
                    stopMonitorChat(chatId);
                }
            }
        }

        agentLEManager.bindToLEValue('change:LEWebAgent.isVisible', function (model, data) {
            if (data) {
                agentTabVisible = true;
                clearChatLinesForVisitor(currentFocusedVisitorId);
            } else {
                agentTabVisible = false;
            }
        });

        function bindToUIEvents(visitorId) {
            window.App.viewEventsHandler.bindEvent({
                appName: visitorId,
                UIEvent: window.App.viewEventsHandler.eventType.VISITOR_FOCUSED,
                callback: changeFocus,
                context: this
            });
            window.App.viewEventsHandler.bindEvent({
                appName: visitorId,
                UIEvent: window.App.viewEventsHandler.eventType.VISITOR_BLURRED,
                callback: changeFocus,
                context: this
            });
            window.App.viewEventsHandler.bindEvent({
                appName: visitorId,
                UIEvent: window.App.viewEventsHandler.eventType.VISITOR_DISPOSED,
                callback: disposeVisitor,
                context: this
            });
        }

        function unbindFromUIEvents(visitorId) {
            window.App.viewEventsHandler.unbindEvent({
                appName: visitorId,
                UIEvent: window.App.viewEventsHandler.eventType.VISITOR_FOCUSED,
                callback: changeFocus,
                context: this
            });
            window.App.viewEventsHandler.unbindEvent({
                appName: visitorId,
                UIEvent: window.App.viewEventsHandler.eventType.VISITOR_BLURRED,
                callback: changeFocus,
                context: this
            });
            window.App.viewEventsHandler.unbindEvent({
                appName: visitorId,
                UIEvent: window.App.viewEventsHandler.eventType.VISITOR_DISPOSED,
                callback: disposeVisitor,
                context: this
            });
        }

        function checkIfVisible() {
            if (typeof agentTabVisible === 'undefined') {
                agentTabVisible = agentLEManager.getLEAttributeValue("LEWebAgent", "isVisible");
            }
            return agentTabVisible && (focusLevel === getDefaultFocusStateID());
        }

        function changeFocus(data) {
            if (data && data.newValue) {
                if (data.newValue.appName == currentFocusedVisitorId && data.newValue.UIEvent === window.App.viewEventsHandler.eventType.VISITOR_BLURRED) {
                    currentFocusedVisitorId = "";
                } else if (data.newValue.UIEvent === window.App.viewEventsHandler.eventType.VISITOR_FOCUSED) {
                    currentFocusedVisitorId = data.newValue.appName + "";
                    clearChatLinesForVisitor(currentFocusedVisitorId);
                }
            }
        }

        function changeExternalFocus(data) {
            if (typeof data !== 'undefined') {
                focusLevel = data;
                clearChatLinesForVisitor(currentFocusedVisitorId);
            }
        }

        function clearChatLinesForVisitor(visitorId, clearEvenIfNotVisible) {
            if (visitorId && (clearEvenIfNotVisible || checkIfVisible())) {
                var counter = 0;
                if (waitingLinesMap[visitorId]) {
                    counter = -waitingLinesMap[visitorId];
                    waitingLinesMap[visitorId] = 0;
                }
                if (counter !== 0) {
                    agentLEManager.triggerLEEvent("onEngagementNotificationManager:newline", {
                        count: counter,
                        visitorId: visitorId
                    });
                }
                removeVisitorFromAcceptedChats(visitorId);
            }
        }

        function removeVisitorFromAcceptedChats(visitorId) {
            var index = lpUtils.getIndexOf(newAcceptedChats, visitorId + '');
            if (index >= 0) {
                newAcceptedChats.splice(index, 1);
                agentLEManager.triggerLEEvent("onEngagementNotificationManager:acceptedChat", {
                    count: -1,
                    visitorId: visitorId
                });
            }
        }


        function removeVisitor(visitorId) {
            if (visitorId) {
                clearChatLinesForVisitor(visitorId);
                removeVisitorFromAcceptedChats(visitorId);
                if (currentFocusedVisitorId === visitorId) {
                    currentFocusedVisitorId = "";
                }
                unbindFromUIEvents(visitorId);
            }
        }

        function disposeVisitor(data) {
            var visitorId = data && data.newValue && data.newValue.appName;
            if (visitorId) {
                removeVisitor(visitorId);
            }
        }

        function verifyVisitorCreated(visitorId) {
            if (typeof waitingLinesMap[visitorId] === 'undefined') {
                waitingLinesMap[visitorId] = 0;
            }
        }

        function updateWaitingLinesMap(count, visitorId) {
            verifyVisitorCreated(visitorId);
            if ((visitorId !== currentFocusedVisitorId || !checkIfVisible()) && isResumed) {
                waitingLinesMap[visitorId] += count;
            } else {
                waitingLinesMap[visitorId] = 0;
            }
        }

        function newChatLine(data) {
            if (!lpTag.WebAgent.logicController.isAcceptedEngagementOrInMyEngagement(this.chatId)) {
                return;
            }

            var lines;
            if (data && data.newValue) {
                lines = data.newValue;
            }
            if (lines) {
                var counter = 0;
                var by, line = null;
                for (var i = 0; i < lines.length; i++) {
                    if (lpTag.WebAgent.logicController.isLineNeedToBeNotified(lines[i], this.chatId)) {
                        counter++;
                        by = lpTag.WebAgent.logicController.getVisitorNameFromTranscript(lines[i].by);
                        line = lines[i];
                    }
                }
                var visitorId = modelController.getModelParam('chats.' + this.chatId + '.visitorInfo.visitorId') + '';
                var notificationEvent = {
                    visitorId: visitorId,
                    chatId: this.chatId,
                    by: by
                };

                if (line) {
                    notificationEvent.text = line.text;

                    if (line.contentType && line.fileType) {
                        notificationEvent.contentType = line.contentType;
                        notificationEvent.fileType = line.fileType;
                    }
                }

                if (!lpTag.WebAgent.logicController.hasUnreadMessagesCounter(this.chatId)) {
                    notificationEvent.count = counter;
                    if (visitorId !== currentFocusedVisitorId || !checkIfVisible()) {
                        updateWaitingLinesMap(counter, visitorId);
                    }
                }
                if (counter > 0 && isResumed) {
                    agentLEManager.triggerLEEvent("onEngagementNotificationManager:newline", notificationEvent);
                }
            }
        }


        function handleAgentUnreadCountUpdate(data) {
            if (data && typeof data.newValue !== "undefined") {
                var counter = data.newValue;
                var visitorId = modelController.getModelParam('chats.' + this.chatId + '.visitorInfo.visitorId') + '';
                if (visitorId !== currentFocusedVisitorId || !checkIfVisible()) {
                    updateWaitingLinesMap(counter - notificationsForVisitor(visitorId), visitorId);
                }
                agentLEManager.triggerLEEvent("onEngagementNotificationManager:newline", {
                    count: counter,
                    visitorId: visitorId,
                    chatId: this.chatId
                });
            }
        }

        function chatAcceptedOrSpectated(data) {
            var visitorId = null;
            if (data && data.visitorInfo && data.visitorInfo.visitorId) {
                visitorId = data.visitorInfo.visitorId + "";
                verifyVisitorCreated(visitorId);

                var isAcceptedEngagement = lpTag.WebAgent.logicController.isAcceptedEngagement(visitorId);
                var activeDialogId = lpTag.WebAgent.logicController.getActiveDialogIdOfConversation(this.chatId);
                var isJoinedAsManager = lpTag.WebAgent.logicController.isLoggedInAgentManagerParticipant(this.chatId, activeDialogId);

                // Making sure that the chatAccepted method doesn't continue if the chat isn't accepted
                if (!(isAcceptedEngagement || isJoinedAsManager)) {
                    return null;
                }

            }

            return visitorId;
        }

        function isValidChatState(state) {
            return state !== chatState.ENDED && state !== chatState.TRANSFERRED;
        }

        function chatAccepted(data) {
            var transformedData = {visitorInfo: {visitorId: data.visitorId}, chatInfo: {chatId: data.chatId}};
            chatAcceptedOrSpectated(transformedData);
            var visitorId = data.visitorId;
            if (visitorId) {
                unbindFromUIEvents(visitorId);
                bindToUIEvents(visitorId);
                if (data.isAutoAccepted) {
                    if (isNewAcceptedChat(visitorId, transformedData)) {
                        newAcceptedChats.push(visitorId);
                        agentLEManager.triggerLEEvent("onEngagementNotificationManager:acceptedChat", {
                            count: 1,
                            visitorId: visitorId
                        });
                    }
                    var resumedIndex = resumedVisitors.indexOf(visitorId);
                    if (resumedIndex >= 0) {
                        resumedVisitors.splice(resumedIndex, 1);
                    }
                }
            }
        }

        /**
         * Returns true if the visitor is new and the chat is a newly accepted chat
         * @param visitorId
         * @param data
         * @returns {boolean|data.chatInfo|{chatId}|{chatId, events, lastUpdate}|*}
         */
        function isNewAcceptedChat(visitorId, data) {
            // We want to make sure we finished resuming, and that the visitor is not resumed
            return isResumed && resumedVisitors.indexOf(visitorId + '') < 0 &&
                // We want to make sure the visitor isn't focused (or that we're not focused in general)
                (visitorId !== currentFocusedVisitorId || !checkIfVisible()) &&
                // We want to make sure that we have a chatId
                data.chatInfo && data.chatInfo.chatId &&
                // We want to make sure the state isn't transferred or ended
                isValidChatState(data.chatInfo.state) &&
                // We want to make sure the visitor isn't simulated
                !lpTag.WebAgent.logicController.isSimulatedVisitor(visitorId);
        }

        function chatStateChanged(data) {
            var visitorId, chatId, state;
            if (data && data.newValue) {
                state = data.newValue;
            }
            if (data && data.key) {
                var splitKeys = data.key.split('.');
                if (splitKeys.length >= 1) {
                    chatId = splitKeys[1];
                }
            }
            visitorId = modelController.getModelParam('chats.' + chatId + '.visitorInfo.visitorId') + '';
            if (visitorId && state && chatId && !isValidChatState(state)) {
                stopMonitorChat(chatId);
            }
        }

        function _unbindFromChatEvents(chatId) {
            if (chatId) {
                modelController.unbindModelParam('chats.' + chatId + '.newChatLine.lines', newChatLine);
                modelController.unbindModelParam('chats.' + chatId + '.chatInfo.state', chatStateChanged);
                if (lpTag.WebAgent.logicController.isEngagementAsyncMessaging(chatId)) {
                    modelController.unbindModelParam('chats.' + chatId + '.agentInfo.loggedInAgentUnreadCount', handleAgentUnreadCountUpdate);
                }
            }
        }

        function _bindToChatEvents(chatId) {
            modelController.bindModelParam('chats.' + chatId + '.chatInfo.state', chatStateChanged);
            modelController.bindModelParam('chats.' + chatId + '.newChatLine.lines', newChatLine, {chatId: chatId}, false);
            if (lpTag.WebAgent.logicController.isEngagementAsyncMessaging(chatId)) {
                modelController.bindModelParam('chats.' + chatId + '.agentInfo.loggedInAgentUnreadCount', handleAgentUnreadCountUpdate, {chatId: chatId}, false);
            }
        }

        function numberOfWaitingChatLines() {
            var sum = 0;
            for (var visitor in waitingLinesMap) {
                sum += waitingLinesMap[visitor];
            }
            return sum;
        }

        function notificationsForVisitor(visitorId) {
            var notifications = 0;
            if (typeof visitorId !== 'undefined' && typeof waitingLinesMap[visitorId] !== 'undefined') {
                notifications += waitingLinesMap[visitorId];
            }
            if (typeof  visitorId !== 'undefined' && newAcceptedChats && newAcceptedChats.indexOf(visitorId) >= 0) {
                notifications++;
            }
            return notifications;
        }

        function numberOfNewAcceptedChats() {
            return newAcceptedChats.length;
        }

        function getCurrentFocusedVisitorId() {
            return currentFocusedVisitorId;
        }

        return {
            applicationType: "EngagementNotificationManager",
            totalNumberOfWaitingChatLines: numberOfWaitingChatLines,
            totalNewAcceptedChats: numberOfNewAcceptedChats,
            getNotificationsForVisitor: notificationsForVisitor,
            getCurrentFocusedVisitorId: getCurrentFocusedVisitorId
        };
    }

    return EngagementNotificationManager;

});
